module.exports = __webpack_public_path__ + "img/settings.6c25c32d.svg";